var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.23672 0 0 2.27175 0 5.07937V6.03175C-1.49566e-06 6.14966 0.0323191 6.26524 0.0933402 6.36555C0.154361 6.46585 0.241672 6.54691 0.345488 6.59964L0.626406 6.74232C0.665684 7.93458 1.62932 8.88889 2.8125 8.88889H3.28125C3.54014 8.88889 3.75 8.67569 3.75 8.4127V4.92064C3.75 4.65764 3.54014 4.44444 3.28125 4.44444H2.8125C2.20035 4.44444 1.64705 4.69998 1.25 5.11165V5.07937C1.25 2.97879 2.93225 1.26984 5 1.26984C7.06775 1.26984 8.75 2.97879 8.75 5.07937V5.11165C8.35295 4.69998 7.79965 4.44444 7.1875 4.44444H6.71875C6.45986 4.44444 6.25 4.65764 6.25 4.92064V8.4127C6.25 8.67569 6.45986 8.88889 6.71875 8.88889H7.1875C8.37068 8.88889 9.33432 7.93456 9.37359 6.74232L9.65449 6.59964C9.75831 6.54691 9.84563 6.46585 9.90665 6.36555C9.96768 6.26525 10 6.14966 10 6.03175V5.07937C10 2.27224 7.76375 0 5 0Z",
    fill: "url(#paint0_linear_773_10166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_10166",
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 8.88889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E2222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help_center.b4b415db1af287ab882f0537cd81e298.svg";
export { ForwardRef as ReactComponent };